var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header",class:_vm.isH5 ? 'h5-page-header' : 'pc-page-header'},[_c('p',{staticClass:"title"},[_c('img',{staticClass:"back",attrs:{"src":require("../../../assets/images/arrow-left.png"),"alt":""},on:{"click":_vm.goBack}}),_c('span',[_vm._v(" "+_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }